import { HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { catchError, EMPTY, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {

  const authService = inject(AuthService);
  const router = inject(Router);

  // if reponse is unauthorized, redirect to login
  return next(req).pipe(
    catchError((error) => {
      if (error.status === HttpStatusCode.Unauthorized) {
        authService.logout();
        authService.logout().then(() => {
          router.navigate(['/login']);
        });
        return EMPTY
      }
      else {
        // handle other errors by the application
        return throwError(() => error);
      }
    })
  );
};
